/**
 * It will read a URL query and return an object with the values.
 *
 * @param {String} url
 * @returns {Object}
 */
export function readURLSearchParams(url) {
  const query = url.replace('?', '');
  if (!query) {
    return {};
  }

  return query.split('&').reduce((params, pair) => {
    if (!pair) {
      return params;
    }
    const separatorIndex = pair.indexOf('=');
    const key = separatorIndex === -1 ? pair : pair.slice(0, separatorIndex);
    const value = separatorIndex === -1 ? '' : pair.slice(separatorIndex + 1);
    params[key] = value;
    return params;
  }, {});
}

/**
 * It will convert an object to a Query URL.
 *
 * @param {Object} data
 * @returns {String}
 */
export function createURLSearchParams(data) {
  return Object.keys(data)
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join('&');
}

export default {
  readURLSearchParams,
  createURLSearchParams,
};
